import { render, staticRenderFns } from "./PscsLoading.vue?vue&type=template&id=1203736c&scoped=true"
import script from "./PscsLoading.vue?vue&type=script&lang=js"
export * from "./PscsLoading.vue?vue&type=script&lang=js"
import style0 from "./PscsLoading.vue?vue&type=style&index=0&id=1203736c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203736c",
  null
  
)

export default component.exports